module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("A Canadian Girl in South Africa")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "image-title"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/Page_11.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Maud Graham, 1908."), _c('br'), _c('span', {
    staticClass: "fig"
  }, [_vm._v("[Joan Chandler private collection]")])])])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55a5cce6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/07_Page_11.vue
// module id = 69
// module chunks = 0